<template>
    <div class="patient-coaching-summary-rtc">
        <b-row class="align-content-around">
            <div class="report-widget col text-center">
                <b-row>
                    <b-col>
                        <label>
                            {{ $i18n.gt('HEADING_RTC_GAUGE') }}
                        </label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-btn class="col btn-sm" variant="primary" @click.stop="showRtcModal()">
                            {{ $i18n.gt('LABEL_VIEW_BUTTON') }}
                        </b-btn>
                    </b-col>
                </b-row>

            </div>
        </b-row>
        <b-modal :id="modalId" :title="$i18n.gt('HEADING_RTC_GAUGE')" hide-footer size="lg">
            <report-rtc-table :widget-keys="widgetKeys"/>
        </b-modal>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>

    import Vue from 'vue'

    export default Vue.extend({
        name: 'PatientCoachingSummaryRtc',
        computed: {
            participant() {
                return this.$store.state.patientParticipant
            },
            modalId() {
                return 'modal_rtc'
            },
        },
        data() {
            return {
                widgetKeys:
                    [['RTC_WELLBEING_SCORE', 'RTC_ENERGY_SCORE', 'RTC_STRESS_SCORE', 'RTC_PRODUCTIVITY_SCORE', 'RTC_SATISFACTION_SCORE', 'RTC_WORK_LIFE_SCORE'],
                        ['RTC_PHYS_ACTIVITY_SCORE', 'RTC_EATING_HABITS_SCORE', 'RTC_WEIGHT_CONTROL_SCORE', 'RTC_SLEEP_SCORE', 'RTC_MANAGE_MEDICAL_SCORE', 'RTC_REDUCE_NEED_MEDS_SCORE'],
                        ['RTC_NICOTINE_SCORE', 'RTC_ALCOHOL_SCORE', 'RTC_DRUG_USE_SCORE']]
            }
        },
        methods: {
            showRtcModal() {
                this.$bvModal.show(this.modalId)
            }
        }
    })
</script>

<style lang="scss">

    .report-widget {
        cursor: pointer;

        .card {
            background: #fff;
            transition: all .3s;
            margin-bottom: 0;
            @media(min-width: 540px) {
                height: 100%;
            }

            &:hover {
                box-shadow: 0 0 10px rgba(0, 0, 0, .15);

                .report-widget__timestamp {
                    color: var(blue);
                }
            }
        }

        @media(max-width: 719px) {
            margin-bottom: 1rem;
        }

    }
</style>
